import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Ajouter un responsable',
    first_name: {
      label: 'Prénom',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Nom',
      placeholder: 'White',
    },
    city: {
      label: 'Ville',
      placeholder: 'Bonn',
    },
    email: {
      label: 'E-mail',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rôle',
      placeholder: 'Sélectionner un rôle',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Propriétaire',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Revendeur',
        [ManagerRole.SalesManager]: 'Responsable des ventes',
        [ManagerRole.SalesLeadership]: 'Chef des ventes',
        [ManagerRole.ContentManager]: 'Responsable du contenu',
        [ManagerRole.OnboardingManager]: "Responsable de l'onboarding",
        [ManagerRole.MobileAppsManager]: 'Responsable des applis mobiles',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Employé',
        [ManagerRole.StoreOperator]: 'Opérateur',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Opérateur :</strong> Accès complet aux Ventes, Menu, Top articles, Horaires, Cartes cadeaux, Réservations et Rapports pour les établissements assignés.',
        [ManagerRole.StoreEmployee]:
          '<strong>Employé :</strong> Accès limité aux Réservations et Cartes cadeaux uniquement.',
        [ManagerRole.StoreAdmin]:
          "<strong>Propriétaire :</strong> Accès complet à un restaurant, incluant la vitrine, les paramètres fiscaux, le marketing et la gestion de l'équipe. Reçoit un e-mail avec ses identifiants. Un seul propriétaire par restaurant, les autres membres ne peuvent pas le modifier ni le supprimer.",
      },
    },
    companies: {
      label: 'Établissements',
      placeholder: 'Sélectionner des établissements',
      owner_placeholder: 'Sélectionner un restaurant',
      has_owner: 'A un propriétaire',
    },
  },
  fields: {
    email: 'E-mail',
    name: 'Nom',
    roles: 'Rôle',
    created_at: 'Créé',
    actions: 'Actions',
    companies: 'Établissements',
    status: 'Statut',
  },
  tags: {
    owner: 'Propriétaire',
    operator: 'Opérateur',
    employee: 'Employé',
  },
  no_owner: {
    title: '{{restaurant}} n’a pas de propriétaire',
    description: 'Tout ce qui nécessite le propriétaire attend qu’un propriétaire soit choisi.',
  },
  search: {
    placeholder: 'Rechercher par nom ou e-mail',
  },
  buttons: {
    add_manager: 'Ajouter un responsable',
    actions: 'Actions',
    view_dashboard: 'Voir le tableau de bord en tant que ce responsable',
    login_as_manager: 'Se connecter en tant que ce responsable',
    delete: 'Supprimer ce responsable',
    resend_owner_invite: "Renvoyer l'invitation du propriétaire",
    save_companies: 'Enregistrer les restaurants de {{name}}',
    change_owner: 'Retirer {{name}} comme propriétaire',
    delete_named: 'Supprimer {{name}}',
    choose_owner: 'Choisir un propriétaire',
  },
  modals: {
    delete_manager: {
      title: 'Confirmer la suppression du responsable {{email}} ?',
    },
    update_manager: {
      title: 'Confirmer la mise à jour du responsable {{email}} ?',
    },
    resend_owner_invite: {
      title: "Renvoyer l'invitation à {{email}} ?",
      description:
        'Le propriétaire reçoit un nouveau mot de passe par e-mail. Son mot de passe actuel cesse de fonctionner.',
    },
  },
  toasts: {
    successfully_created_manager: 'Responsable créé avec succès',
    owner_invited:
      '{{email}} a été invité(e) en tant que propriétaire du restaurant et recevra ses identifiants de connexion par e-mail.',
    failed_to_load_data: 'Échec du chargement des données, veuillez actualiser la page',
    failed_to_create_manager: 'Échec de la création du responsable',
    failed_to_create_magic_link: 'Échec de la création du lien magique',
    failed_to_delete_manager: 'Échec de la suppression du responsable',
    manager_got_deleted: 'Responsable supprimé',
    successfully_updated_manager: 'Responsable mis à jour',
    failed_to_update_manager: 'Échec de la mise à jour du responsable',
    owner_invite_resent: "L'invitation a de nouveau été envoyée à {{email}}, avec un nouveau mot de passe.",
    owner_invite_resend_cooling_down:
      "L'invitation vient d'être renvoyée. Patientez quelques minutes avant de la renvoyer.",
    failed_to_resend_owner_invite: "Échec du renvoi de l'invitation",
    owner_changed: '{{name}} est maintenant propriétaire',
    owner_changed_new: '{{name}} est maintenant propriétaire. Identifiants envoyés à {{email}}',
    owner_removed: '{{name}} n’est plus propriétaire',
  },
};
